import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-two-fa-confirmation',
    templateUrl: './two-fa-confirmation.component.html',
    styleUrl: './two-fa-confirmation.component.scss',
    standalone: false
})
export class TwoFaConfirmationComponent {
  constructor(
    public dialogRef: MatDialogRef<TwoFaConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }
  ) {}
}
